module.exports = __webpack_public_path__ + "img/za.0cbf0e33.svg";